<div class="tags" *ngIf="tags?.length > 0">
  <ng-container *ngFor="let tag of tags; let i = index">
    <a class="tag" [routerLink]="['/novice?tags_in=' + tag.id]" *ngIf="limit == null || i < limit">{{tag.name}}</a>
  </ng-container>
</div>
